import React from 'react';
import TitleHeader from 'components/presenters/header/TitleHeader';
import PasswordResetRequestForm from 'components/containers/password/PasswordResetRequestForm';
import {Layout, HeaderLayout, BodyLayout} from './style';
export default function PasswordResetRequestLayout() {
	return (
		<Layout>
			<HeaderLayout>
				<TitleHeader isCloseBtn={true} prevURL={"/login"} title={"비밀번호 재설정"} borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"}/>
			</HeaderLayout>
			<BodyLayout>
				<PasswordResetRequestForm />
			</BodyLayout>
		</Layout>)
}